import { Document, Font, Image, Page, PDFViewer, StyleSheet, Text, View } from "@react-pdf/renderer";
import React, { Component, Fragment } from "react";
import { Button } from "react-bootstrap";
import i18n from "../../../../i18n";
import { formatNumber } from "../../Class/FormatNumber";

Font.register({
    family: 'Times-Roman',
    fonts: [
        { src: 'assets/fonts/times.ttf', fontWeight: 400 },
        { src: 'assets/fonts/timesbd.ttf', fontWeight: 900 }
    ]
});
const borderColor = '#90e5fc'
const styles = StyleSheet.create({

    //  page: {
    //     // padding: 5,
    //     fontSize: 9,
    //     fontFamily: 'Helvetica',
    //     display: 'flex',
    //     flexDirection: 'column',
    //     justifyContent: 'flex-end',
    // },
  signatureSection: {
    marginTop: 5,
    flexDirection: 'row',
    justifyContent: 'space-around',
    textAlign: 'center',
  },
  signatureBox: {
    width: '30%',
    // border: '1px solid #000',
    marginLeft : '10px'

  },
  label: {
    marginBottom: 30,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  line: {
    borderBottom: '1pt solid #000',
    width: '100%',
    marginTop: 10,
  },
  namePlaceholder: {
    marginTop: 20,
    fontSize: 10,
    color: '#555',
  },
    logo: {
        width: '50px',
        height: '46.5px',
        padding: '10px',
        border: '1px solid black',
    },
    body: {
        padding: "20px",
    },
    row: {

        flex: 1,
        flexDirection: 'row',
    },
    col: {
        flex: 1,
        flexDirection: 'column',
    },
    colBorder: {
        flex: 1,
        border: 1,
        flexDirection: 'column',
    },
    block: {
        flexGrow: 1,
    },
    tr: {
        flexDirection: 'row',
    },
    td: {
        flexDirection: 'column',
    },

    //Header
    trHeader: {
        backgroundColor: '#afcace',
        borderBottom: '1px',
        flexDirection: 'row',
    },
    trSign: {
        borderBottom: '1px',
        flexDirection: 'row',
        textAlign:'center'
    },
    menuHeader: {
        textAlign: 'center',
        fontFamily: 'Times-Bold',
        fontSize: "8px",
        borderRight: '1px',
        padding: '2px'
    },
    menuSign: {
        textAlign: 'center',
        fontFamily: 'Times-Bold',
        fontSize: "8px",
        borderRight: '1px',
        padding: '5px'
    },
    textFill: {
        textAlign: 'center',
        fontSize: "7px",
        borderRight: '1px',
        borderBottom: '1px',
    },
    textFillLeft: {
        textAlign: 'left',
        fontSize: "7px",
        borderRight: '1px',
        borderBottom: '1px',
        paddingLeft: '1px'
    },
    titleContainer: {
        flexDirection: 'row',
    },
    header: {
        fontSize: "18px",
        fontFamily: 'Times-Roman'
    },
    address: {
        fontSize: "12px",
        fontFamily: 'Times-Roman'
    },
    titleTranx: {
        fontSize: "10px",
        fontWeight: 700,
        fontFamily: 'Times-Bold',
        textAlign: 'center'
    },

    tableTitle: {
        border: '1px solid black',
        fontSize: "8px",
        fontWeight: 400,
        fontFamily: 'Times-Roman',
        padding: '1px',
    },

    table: {
        fontSize: "8px",
        fontWeight: 400,
        fontFamily: 'Times-Roman',
        padding: '1px',
    },


    //End Header

    //Table Item
    fillText: {
        textAlign: 'left',
        fontSize: "8px",
        padding: '1px',
        fontWeight: 700,
        fontFamily: 'Times-Bold',
        textAlign: 'center'
    },

    fillTextColor: {
        textAlign: 'left',
        fontSize: "8px",
        padding: '1px',
        fontWeight: 700,
        fontFamily: 'Times-Bold',
        textAlign: 'center'
    },

    fillTextLeft: {
        textAlign: 'left',
        fontSize: "8px",
        padding: '5px',
        fontWeight: 700,
        fontFamily: 'Times-Bold',
    },

    //end Table

    //Footer
    footer: {
        position: 'absolute',
        bottom: 0
    },

    breakPage: { pageBreakBefore: "always" },
    //end Footer
});
const tableRowsCount = 11;
class PrintReturnGoods extends Component {
    constructor(props) {
        super(props)
        this.state = {
            itemsPerPage: 15,
            dataTaking:null,
            title: i18n.t("BUKTI PENGAMBILAN DAN PENGEMBALIAN BARANG"),
            merchant: {
                email: null,
                fax: null,
                logo: '/assets/media/logos/logo.jpg',
                name: "CV. CELEBES PUTERA SEJAHTERA",
                phone: null,
                website: null,
                address: []
            },
            logo: '/assets/media/logos/logo.jpg',
            data: {
                poNo: '',
                po_detail: []
            }
        };
    }
    renderMessage() {
        const { isProcessing, requestPrint } = this.props
        switch (true) {
            case isProcessing:
                return (
                    <div style={loader}>
                        <div className="spinner-border text-primary" style={{ width: '10rem', height: '10rem' }} role="status"></div><br />
                        <div style={{ fontSize: 36 }}>Getting Data From Server</div>
                    </div>)
            case requestPrint:
                return (
                    <div style={loader}>
                        {/* <div className="spinner-border text-primary" style={{width: '10rem', height: '10rem'}} role="status"></div><br/> */}
                        <div style={{ fontSize: 36 }}>Please Wait Response from Head Office </div>
                        <div><Button variant="primary" onClick={() => { this.props.getPrint(this.props.poid) }}>Reload Page</Button></div>
                    </div>)
        }
    }

    // renderSign(data) {
    //     let arr = data ?? {};
    //     return (
    //         <Fragment>
    //             <View fixed style={styles.table}  >
    //                 <View style={styles.trSign} >
    //                     <Text style={[styles.menuSign, { width: '25%', borderTop: '1px', borderLeft: '1px' }]}>{i18n.t("Diserahkan Oleh,")}</Text>
    //                     <Text style={[styles.menuSign, { width: '25%', borderTop: '1px' }]}>{i18n.t("Diterima Oleh,")}</Text>
    //                     <Text style={[styles.menuSign, { width: '25%', borderTop: '1px' }]}>{i18n.t("Disaksikan Oleh,")}</Text>
    //                     <Text style={[styles.menuSign, { width: '25%', borderTop: '1px' }]}>{i18n.t("Disetujui Oleh,")}</Text>
    //                 </View>
    //                 <View style={styles.trSign}>
    //                     <Text style={[styles.menuSign, { width: '25%', borderRight: '1px', minHeight: '50px', borderLeft: '1px' }]}>{i18n.t("")}</Text>
    //                     <Text style={[styles.menuSign, { width: '25%', borderRight: '1px' }]}>{i18n.t("")}</Text>
    //                     <Text style={[styles.menuSign, { width: '25%', borderRight: '1px' }]}>{i18n.t("")}</Text>
    //                     <Text style={[styles.menuSign, { width: '25%', borderRight: '1px' }]}>{i18n.t("")}</Text>
    //                 </View>
    //                 <View style={styles.trSign}>
    //                     <Text style={[styles.menuSign, { width: '25%', borderRight: '1px', borderLeft: '1px' }]}>{i18n.t(arr.created_by)}</Text>
    //                     <Text style={[styles.menuSign, { width: '25%', borderRight: '1px' }]}>{i18n.t("")}</Text>
    //                     <Text style={[styles.menuSign, { width: '25%', borderRight: '1px' }]}>{i18n.t(arr.name_sales)}</Text>
    //                     <Text style={[styles.menuSign, { width: '25%', borderRight: '1px' }]}>{i18n.t("")}</Text>
    //                 </View>
    //             </View>
    //         </Fragment>
    //     );
    // }

    renderSignBaru(data) {
        let arr = data ?? {};
        return (
            <Fragment>
                <View style={styles.signatureSection}>
                    <View style={styles.signatureBox}>
                        <Text style={styles.label}>Diserahkan</Text>
                    <View style={styles.line} />
                        <Text style={styles.namePlaceholder}>{""}</Text>
                    </View>
                    <View style={styles.signatureBox}>
                    <Text style={styles.label}>Diterima</Text>
                    <View style={styles.line} />
                    <Text style={styles.namePlaceholder}>{""}</Text>
                    </View>
                    <View style={styles.signatureBox}>
                    <Text style={styles.label}>Disetujui</Text>
                    <View style={styles.line} />
                    <Text style={styles.namePlaceholder}>{""}</Text>
                    </View>
                </View>
            </Fragment>
        );
    }

    renderData(data,dataReturn) {
        let taking = this.state.dataTaking;
        let html = [];
        let unit = [3, 1, 4, 5];

        // console.log("DATA",data.taking)
        if (data.taking.length > 0) {
            let retur = [];
            let arr = data.taking;
            let arrRet = dataReturn;
            let convertion = [];
            for (var i = 0; i < this.state.itemsPerPage; i++) {
                if (arr[i] != null) {
                    convertion = arr[i].detail;
                    retur = arrRet[i].detail;
                    // retur = arr[i].retur;
                    html.push(
                        <View style={styles.tr} >
                            <Text style={[styles.textFill, { width: '5%', borderLeft: '1px' }]} key={"no" + i}>{i + 1}</Text>
                            <Text style={[styles.textFillLeft, { width: '25%', }]} key={"item" + i}>{arr[i].name_item}</Text>
                            <Text style={[styles.textFill, { width: '7%', }]} key={"item" + i}>{arr[i].band_no}</Text>
                            {arr[i]?.detail.length > 0 ?
                                unit.map((value, p) => {
                                    const index = arr[i]?.detail.findIndex(convertion => convertion.id.includes(value));
                                    if (index !== -1) {
                                        return (<Text style={[styles.textFill, { width: '7%', }]} key={convertion[index].label + p}>{convertion[index].qty}</Text>);
                                    } else {
                                        return (<Text style={[styles.textFill, { width: '7%', }]} key={"item" + p}>{""}</Text>);
                                    } 

                                }) 
                                : null}
                            {/* {this.renderReturn()} */}
                            {retur.length > 0 ?
                                unit.map((value, p) => {
                                    const index = retur.findIndex(retur => retur.id.includes(value));
                                    if (index !== -1) {
                                        return (<Text style={[styles.textFill, { width: '7%', }]} key={"item" + p}>{retur[index].qty > 0 ? formatNumber(retur[index].qty) : ""}</Text>);
                                    } else {
                                        return (<Text style={[styles.textFill, { width: '7%', }]} key={"item" + p}>{""}</Text>);
                                    }

                                }) :
                                unit.map((value, p) => {
                                    return (<Text style={[styles.textFill, { width: '7%', }]} key={"item" + p}>{""}</Text>);
                                })}
                            <Text style={[styles.textFill, { width: '9%', }]} key={"item" + i}>{arr[i].selling>0? formatNumber(arr[i].selling):''}</Text>
                        </View>
                    );
                } else {
                    html.push(
                        <View style={styles.tr}>
                            <Text style={[styles.textFill, { width: '5%', borderLeft: '1px' }]} key={"no" + i}>{i + 1}</Text>
                            <Text style={[styles.textFill, { width: '25%', }]} key={"item" + i}>{""}</Text>
                            <Text style={[styles.textFill, { width: '7%', }]} key={"item" + i}>{""}</Text>
                            {unit.length > 0 ?
                                unit.map((value, p) => {
                                    return (<Text style={[styles.textFill, { width: '7%', }]} key={"item" + p}>{""}</Text>);
                                }) : null}
                            {unit.length > 0 ?
                                unit.map((value, p) => {
                                    return (<Text style={[styles.textFill, { width: '7%', }]} key={"item" + p}>{""}</Text>);
                                }) : null}
                            <Text style={[styles.textFill, { width: '9%', }]} key={"item" + i}>{""}</Text>
                        </View>

                    );
                }

            }
        }

        return html;
    }

    renderDataPOSM(data,dataReturn) {
        let taking = this.state.dataTaking;
        let html = [];
        // let unit = [3, 1, 4, 5];

        // console.log("DATA",data.taking)
        if (data.taking.length > 0) {
            let retur = [];
            let arr = data.taking;
            let arrRet = dataReturn;
            let convertion = [];
            let width = (28 / (data.units.length)) + "%";
            for (var i = 0; i < this.state.itemsPerPage; i++) {
                if (arr[i] != null) {
                    convertion = arr[i].detail;
                    retur = arrRet[i].detail;
                    // retur = arr[i].retur;
                    html.push(
                        <View style={styles.tr} >
                            <Text style={[styles.textFill, { width: '5%', borderLeft: '1px' }]} key={"no" + i}>{i + 1}</Text>
                            <Text style={[styles.textFillLeft, { width: '25%', }]} key={"item" + i}>{arr[i].name_item}</Text>
                            <Text style={[styles.textFill, { width: '7%', }]} key={"item" + i}>{arr[i].band_no}</Text>
                            {arr[i]?.detail.length > 0 ?
                                data.units.map((value, p) => {
                                    const index = arr[i]?.detail.findIndex(cons => cons.id.includes(value.id));
                                    if (index !== -1) {
                                        return (<Text style={[styles.textFill, { width: width, }]} key={convertion[index].label + p}>{convertion[index].qty}</Text>);
                                    } else {
                                        return (<Text style={[styles.textFill, { width: width, }]} key={"item" + p}>{""}</Text>);
                                    } 

                                }) 
                                : null}
                            {/* {this.renderReturn()} */}
                            {retur.length > 0 ?
                                data.units.map((value, p) => {
                                    const index = retur.findIndex(retur => retur.id.includes(value.id));
                                    if (index !== -1) {
                                        return (<Text style={[styles.textFill, { width: width, }]} key={"item" + p}>{retur[index].qty > 0 ? formatNumber(retur[index].qty) : ""}</Text>);
                                    } else {
                                        return (<Text style={[styles.textFill, { width: width, }]} key={"item" + p}>{""}</Text>);
                                    }

                                }) :
                                data.units.map((value, p) => {
                                    return (<Text style={[styles.textFill, { width: width, }]} key={"item" + p}>{""}</Text>);
                                })}
                            <Text style={[styles.textFill, { width: '9%', }]} key={"item" + i}>{arr[i].selling>0? formatNumber(arr[i].selling):''}</Text>
                        </View>
                    );
                } else {
                    html.push(
                        <View style={styles.tr}>
                            <Text style={[styles.textFill, { width: '5%', borderLeft: '1px' }]} key={"no" + i}>{i + 1}</Text>
                            <Text style={[styles.textFill, { width: '25%', }]} key={"item" + i}>{""}</Text>
                            <Text style={[styles.textFill, { width: '7%', }]} key={"item" + i}>{""}</Text>
                            {data.units.length > 0 ?
                                data.units.map((value, p) => {
                                    return (<Text style={[styles.textFill, { width: width, }]} key={"item" + p}>{""}</Text>);
                                }) : null}
                            {data.units.length > 0 ?
                                data.units.map((value, p) => {
                                    return (<Text style={[styles.textFill, { width: width, }]} key={"item" + p}>{""}</Text>);
                                }) : null}
                            <Text style={[styles.textFill, { width: '9%', }]} key={"item" + i}>{""}</Text>
                        </View>

                    );
                }

            }
        }

        return html;
    }

     renderMenuPOSM(taking, dataReturn) {
        let html = [];
        let arr = taking.units;
        let width = (28 / (arr.length)) + "%";
        html.push(
            <View fixed style={styles.table}  >
                <View style={styles.trHeader} >
                    <Text style={[styles.menuHeader, { width: '5%', borderTop: '1px', borderLeft: '1px' }]} key={"menu_no"}>{i18n.t("No.")}</Text>
                    <Text style={[styles.menuHeader, { width: '25%', borderTop: '1px' }]}>{i18n.t("JENIS BARANG / MERK")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%', borderTop: '1px' }]}>{i18n.t("PITA")}</Text>
                    <Text style={[styles.menuHeader, { width: '28%', borderTop: '1px' }]}>{i18n.t("DO")}</Text>
                    <Text style={[styles.menuHeader, { width: '28%', borderTop: '1px' }]}>{i18n.t("KEMBALI")}</Text>
                    <Text style={[styles.menuHeader, { width: '9%', borderTop: '1px' }]}>{i18n.t("JUAL")}</Text>
                </View>
                <View style={styles.trHeader} >
                    <Text style={[styles.menuHeader, { width: '5%', borderLeft: '1px' }]}>{i18n.t("")}</Text>
                    <Text style={[styles.menuHeader, { width: '25%' }]}>{i18n.t("")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("")}</Text>
                    {arr.length>0?
                        arr.map((item, i)=>{
                             return <Text style={[styles.menuHeader, { width: width }]}>{i18n.t(item.label)}</Text>
                        })
                        :null
                    }
                    {arr.length>0?
                        arr.map((item, i)=>{
                             return <Text style={[styles.menuHeader, { width: width }]}>{i18n.t(item.label)}</Text>
                        })
                        :null
                    }
                    {/* <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("BOX")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("BALL")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("SLOP")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("BKS")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("BOX")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("BALL")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("SLOP")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("BKS")}</Text> */}
                    <Text style={[styles.menuHeader, { width: '9%' }]}>{i18n.t("")}</Text>
                </View>
                <View>
                    {this.renderDataPOSM(taking,dataReturn)}
                </View>
            </View>

        );
        return html;
    }

    renderMenu(taking, dataReturn) {
        let html = [];

        html.push(
            <View fixed style={styles.table}  >
                <View style={styles.trHeader} >
                    <Text style={[styles.menuHeader, { width: '5%', borderTop: '1px', borderLeft: '1px' }]} key={"menu_no"}>{i18n.t("No.")}</Text>
                    <Text style={[styles.menuHeader, { width: '25%', borderTop: '1px' }]}>{i18n.t("JENIS BARANG / MERK")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%', borderTop: '1px' }]}>{i18n.t("PITA")}</Text>
                    <Text style={[styles.menuHeader, { width: '28%', borderTop: '1px' }]}>{i18n.t("DO")}</Text>
                    <Text style={[styles.menuHeader, { width: '28%', borderTop: '1px' }]}>{i18n.t("KEMBALI")}</Text>
                    <Text style={[styles.menuHeader, { width: '9%', borderTop: '1px' }]}>{i18n.t("JUAL")}</Text>
                </View>
                <View style={styles.trHeader} >
                    <Text style={[styles.menuHeader, { width: '5%', borderLeft: '1px' }]}>{i18n.t("")}</Text>
                    <Text style={[styles.menuHeader, { width: '25%' }]}>{i18n.t("")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("BOX")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("BALL")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("SLOP")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("BKS")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("BOX")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("BALL")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("SLOP")}</Text>
                    <Text style={[styles.menuHeader, { width: '7%' }]}>{i18n.t("BKS")}</Text>
                    <Text style={[styles.menuHeader, { width: '9%' }]}>{i18n.t("")}</Text>
                </View>
                <View>
                    {this.renderData(taking,dataReturn)}
                </View>
            </View>

        );
        return html;
    }

    render() {
        const { dataPrint } = this.props
        console.log(dataPrint)
        let dataReturn = null;
        let dataBPPB = null;
        let dataTaking = null;
        let itemsPerPage = this.state.itemsPerPage;
        let pages = [];

        if (dataPrint != null) {
            dataReturn = dataPrint.type ?? [];
            dataBPPB = dataPrint.bppb ?? [];
            
        //     dataTaking = dataPrint.taking ?? [];
        //     this.state.dataTaking = dataPrint.taking ?? [];
        //     dataMenu = dataPrint.unit ?? [];

        //     let detailReturn = dataReturn.details;

            // for (let i = 0; i < detailReturn.length; i += itemsPerPage) {
            //     // pages.push(detailReturn.slice(i, i + itemsPerPage));
            // }

        }
        console.log(dataBPPB)
        return (
            <React.Fragment>{(dataPrint != null) ?
                <PDFViewer width={"100%"} height={"100%"} >
                    <Document title={this.state.title + ((dataPrint != undefined) ? "" : "")}>
                        {dataReturn.map((items, pageIndex) => (
                            <Fragment>
                            <Page wrap size={"A4"} style={styles.page} orientation={"landscape"}>
                                <View style={styles.body}>
                                    <View style={styles.titleContainer}>
                                        <View style={styles.row}>
                                            {/* <View style={[styles.col, { width: '100%' }]} > */}
                                            <View style={[styles.col, { width: '48%' }]} >
                                                <View style={styles.tableTitle}>
                                                    <View style={[styles.tr, { width: '100%' }]}>
                                                        <View style={[styles.td]} >
                                                            <View>
                                                                <Image src={(this.state.merchant.logo != null) ? this.state.merchant.logo : "/assets/media/logos/logo.jpg"} style={styles.logo} />
                                                            </View>
                                                        </View>
                                                        {/* <View style={[styles.td, { width: '100%' }]}> */}
                                                        <View style={[styles.td, { width: '88%' }]}>
                                                            <View style={styles.titleTranx}>
                                                                <Text style={{ border: '1px solid black', padding: '5px' }}>{i18n.t("BUKTI PENGAMBILAN DAN PENGEMBALIAN BARANG")}</Text>
                                                            </View>
                                                            <View style={styles.titleTranx}>
                                                                <Text style={{ border: '1px solid black', padding: '5px' }}>{i18n.t(dataPrint.branch || '') + (dataPrint.store != "" ? " - " + dataPrint.store : "")} </Text>
                                                            </View>
                                                        </View>
                                                    </View>
                                                    <View style={styles.tr}>
                                                        <View style={[styles.td, { width: '25%', border: '1px solid black', backgroundColor :'#c5e3e7' }]} >
                                                            <View style={styles.fillText}>
                                                                <Text>No Formulir : </Text>
                                                                {/* <Text>{dataReturn?.transaction_no || ''} </Text> */}
                                                            </View>
                                                        </View>
                                                        <View style={[styles.td, { width: '25%', border: '1px solid black', backgroundColor :'#c5e3e7'  }]} >
                                                            <View style={styles.fillText}>
                                                                <Text>Revisi : 00</Text>
                                                            </View>
                                                        </View>
                                                        <View style={[styles.td, { width: '25%', border: '1px solid black', backgroundColor :'#c5e3e7'  }]} >
                                                            <View style={styles.fillText}>
                                                                <Text>Tanggal Efektif : </Text>
                                                                <Text>{dataPrint?.date || ''}</Text>
                                                            </View>
                                                        </View>
                                                        <View style={[styles.td, { width: '25%', border: '1px solid black', backgroundColor :'#c5e3e7'  }]} >
                                                            <View style={styles.fillText}>
                                                                <Text>{"Halaman : " + (pageIndex + 1) + ' dari ' + (pages.length)}</Text>
                                                            </View>
                                                        </View>
                                                    </View>

                                                    <View style={[styles.tr, { 'paddingTop': '5px' }]}></View>

                                                    <View style={styles.tr}>
                                                        <View style={[styles.td, { width: '65%' }]} >
                                                            <View style={styles.fillTextLeft}>
                                                                <Text>Tanggal : {dataPrint?.date || ''} </Text>
                                                                {/* <Text>No. BPPB : {dataBPPB.join(', ')}</Text>
                                                                 */}
                                                                 <Text>No. BPPB :</Text>
                                                                    {dataBPPB.map((item, i) => (
                                                                        <Text key={i}>  {item}</Text>
                                                                    ))}
                                                                <Text>Tipe Barang : {items?.name_type}</Text>
                                                            </View>
                                                        </View>

                                                        <View style={[styles.td, { width: '15%', border: '1px solid black', backgroundColor :'#c5e3e7' }]} >
                                                            <Text style={[styles.fillTextColor, { borderBottom: '1px' }]}>{i18n.t("No. Doc")}</Text>
                                                            <Text style={[styles.fillTextColor]}>{i18n.t("Lembar")}</Text>
                                                        </View>
                                                        <View style={[styles.td, { width: '20%', border: '1px solid black' }]} >
                                                            <Text style={[styles.fillTextColor, { borderBottom: '1px' }]}>{i18n.t("   ")}</Text>
                                                            <Text style={[styles.fillTextColor]}>{i18n.t("1 (GUDANG)")}</Text>
                                                        </View>
                                                    </View>

                                                    <View style={[styles.tr, { 'paddingTop': '5px' }]}></View>
                                                    <View style={styles.tr}>
                                                        {items.name_type == "POSM" ?
                                                            this.renderMenuPOSM(items.taking,items.return) :
                                                            this.renderMenu(items.taking,items.return)
                                                      
                                                        }
                                                    </View>

                                                    <View style={[styles.tr, { 'paddingTop': '5px' }]}></View>
                                                    <View style={[styles.tr]}>
                                                        <View style={[styles.td, { width: '100%' }]}>
                                                            <Text style={[styles.titleTranx, { padding: '3px', backgroundColor:'#D3D3D3' }]}>{i18n.t("DO")}</Text>
                                                        </View>
                                                    </View>
                                                    <View style={styles.tr}>
                                                        {this.renderSignBaru(dataReturn)}
                                                    </View>
                                                    <View style={[styles.tr]}>
                                                        <View style={[styles.td, { width: '100%' }]}>
                                                            <Text style={[styles.titleTranx, { padding: '3px', backgroundColor:'#D3D3D3' }]}>{i18n.t("KEMBALI")}</Text>
                                                        </View>
                                                    </View>
                                                    <View style={styles.tr}>
                                                        {this.renderSignBaru(dataReturn)}
                                                    </View>
                                                </View>
                                            </View>

                                            {/* SEKAT */}
                                            {/* <View style={[styles.col, { width: '1%' }]} >
                                            </View>  */}


                                            {/* PENGEMBALIAN    */}
                                            <View style={[styles.col, { width: '48%' }]} >
                                                <View style={styles.tableTitle}>
                                                    <View style={[styles.tr, { width: '100%' }]}>
                                                        <View style={[styles.td]} >
                                                            <View>
                                                                <Image src={(this.state.merchant.logo != null) ? this.state.merchant.logo : "/assets/media/logos/logo.jpg"} style={styles.logo} />
                                                            </View>
                                                        </View>
                                                        <View style={[styles.td, { width: '88%' }]}>
                                                            <View style={styles.titleTranx}>
                                                                <Text style={{ border: '1px solid black', padding: '5px' }}>{i18n.t("BUKTI PENGAMBILAN DAN PENGEMBALIAN BARANG")}</Text>
                                                            </View>
                                                            <View style={styles.titleTranx}>
                                                                <Text style={{ border: '1px solid black', padding: '5px' }}>{i18n.t(dataPrint?.branch || '') + (dataPrint.store != "" ? " - " + dataPrint.store : "")} </Text>
                                                            </View>
                                                        </View>
                                                    </View>
                                                    <View style={styles.tr}>
                                                        <View style={[styles.td, { width: '25%', border: '1px solid black', backgroundColor :'#c5e3e7' }]} >
                                                            <View style={styles.fillText}>
                                                                <Text>No Formulir : </Text>
                                                                <Text>{dataReturn?.transaction_no || ''} </Text>
                                                            </View>
                                                        </View>
                                                        <View style={[styles.td, { width: '25%', border: '1px solid black', backgroundColor :'#c5e3e7' }]} >
                                                            <View style={styles.fillText}>
                                                                <Text>Revisi : 00</Text>
                                                            </View>
                                                        </View>
                                                        <View style={[styles.td, { width: '25%', border: '1px solid black', backgroundColor :'#c5e3e7' }]} >
                                                            <View style={styles.fillText}>
                                                                <Text>Tanggal Efektif : </Text>
                                                                <Text>{dataPrint?.date || ''}</Text>
                                                            </View>
                                                        </View>
                                                        <View style={[styles.td, { width: '25%', border: '1px solid black', backgroundColor :'#c5e3e7' }]} >
                                                            <View style={styles.fillText}>
                                                                <Text>{"Halaman : " + (pageIndex + 1) + ' dari ' + (pages.length)}</Text>
                                                            </View>
                                                        </View>
                                                    </View>

                                                    <View style={[styles.tr, { 'paddingTop': '5px' }]}></View>

                                                    <View style={styles.tr}>
                                                        <View style={[styles.td, { width: '65%' }]} >
                                                            <View style={styles.fillTextLeft}>
                                                                <Text>Tanggal : {dataPrint?.date || ''} </Text>
                                                                {/* <Text>No. BPPB : </Text>
                                                                 */}
                                                                 <Text>No. BPPB :</Text>
                                                                    {dataBPPB.map((item, i) => (
                                                                        <Text key={i}>  {item}</Text>
                                                                    ))}
                                                                <Text>Tipe Barang : {items?.name_type}</Text>

                                                            </View>
                                                        </View>

                                                        <View style={[styles.td, { width: '15%', border: '1px solid black', backgroundColor :'#c5e3e7' }]} >
                                                            <Text style={[styles.fillTextColor, { borderBottom: '1px' }]}>{i18n.t("No. Doc")}</Text>
                                                            <Text style={[styles.fillTextColor]}>{i18n.t("Lembar")}</Text>
                                                        </View>
                                                        <View style={[styles.td, { width: '20%', border: '1px solid black' }]} >
                                                            <Text style={[styles.fillTextColor, { borderBottom: '1px' }]}>{i18n.t("   ")}</Text>
                                                            <Text style={[styles.fillTextColor]}>{i18n.t("2 (PENERIMA)")}</Text>
                                                        </View>
                                                    </View>

                                                    <View style={[styles.tr, { 'paddingTop': '5px' }]}></View>
                                                    <View style={styles.tr}>
                                                        {items.name_type == "Good Stock" ?
                                                            this.renderMenu(items.taking,items.return)
                                                            : this.renderMenuPOSM(items.taking,items.return)
                                                        }
                                                    </View>

                                                    <View style={[styles.tr, { 'paddingTop': '5px' }]}></View>
                                                    <View style={[styles.tr]}>
                                                        <View style={[styles.td, { width: '100%' }]}>
                                                            <Text style={[styles.titleTranx, { padding: '3px', backgroundColor:'#D3D3D3' }]}>{i18n.t("DO")}</Text>
                                                        </View>
                                                    </View>
                                                    <View style={styles.tr}>
                                                        {this.renderSignBaru(dataReturn)}
                                                    </View>
                                                    <View style={[styles.tr]}>
                                                        <View style={[styles.td, { width: '100%' }]}>
                                                            <Text style={[styles.titleTranx, { padding: '3px', backgroundColor:'#D3D3D3' }]}>{i18n.t("KEMBALI")}</Text>
                                                        </View>
                                                    </View>
                                                    <View style={styles.tr}>
                                                        {this.renderSignBaru(dataReturn)}
                                                    </View>
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </Page>
                            </Fragment>
                        ))}
                    </Document>
                </PDFViewer>
                :
                this.renderMessage()}

            </React.Fragment>

        )
    }
}

export default PrintReturnGoods;

const loader = {
    alignItems: 'center',
    background: '#FFF',
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    justifyContent: 'center',
    left: 0,
    position: 'fixed',
    top: 0,
    transition: 'opacity 0.2s linear',
    width: '100%',
    opacity: 1,
    transform: 'opacity 1s linear',
}